






























import Vue from 'vue'
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import Legenda from './Legenda.vue'
import {localizeMixin} from '../../mixins'

export default Vue.extend({
    mixins: [localizeMixin],
    components: {
        Legenda
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('user', ['eUnOperatoreGestionaleReport']),
        ...mapState('user', ['userInfo']),
        isHome() {
            return ['IndexReport', 'IndexReportSenzaComune'].indexOf(this.$route.name) >= 0
        },
        isAdmin() {
            return ['IndexReportAdmin'].indexOf(this.$route.name) >= 0
        }
    },
    methods: {
        ...mapActions('modal', ['showModal', 'showNotification']),
        ...mapActions('auth', ['logout']),
        ...mapMutations('modal', ['SET_NUOVE_COORDINATE']),
        goToAdmin() {
            this.$router.push({
                name: 'IndexReportAdmin', params: {
                    comune: this.userInfo.comune.nome
                }
            })
        },
        goToMappa() {
            this.$router.push({
                name: 'IndexReport', params: {
                    comune: this.userInfo.comune.nome
                }
            })
        }
    }
})
